module.exports = __webpack_public_path__ + "static/media/banner.7d65a5dd.jpg";